export const sendForm = (
  action: string,
  values: Record<string, string | number | null | undefined>,
) => {
  const form = document.createElement('form');

  form.action = action;
  form.method = 'POST';
  form.hidden = true;

  Object.entries(values)
    .filter(([, value]) => !!value)
    .forEach(([key, value]) => {
      const input = document.createElement('input');

      input.type = 'text';
      input.name = key;
      input.value = String(value);
      form.appendChild(input);
    });

  const button = document.createElement('button');

  button.type = 'submit';
  form.appendChild(button);

  document.body.appendChild(form);
  button.click();
};
